import { useTranslation } from 'react-i18next';
import { EditPositionPreferencesSection } from '../edit-position-preferences-section/edit-position-preferences-section.component';
import STRING_KEYS from '../../../../language/keys';
import { SuggestionListContainer } from '../edit-position-dialog.styled';
import RequirementChip
  from '../../../../modules/create-position/components/create-position-requirement-chip/create-position-requirement-chip.component';
import { CompanySizeTierEnum } from '../../../../enums/company-size-tier.enum';
import { CompanySizeSectionProps } from './company-size-section';

const companySizeConfig = [
  { size: CompanySizeTierEnum.Small, title: 'Small' },
  { size: CompanySizeTierEnum.Medium, title: 'Medium' },
  { size: CompanySizeTierEnum.Large, title: 'Corporate' },
  { size: CompanySizeTierEnum.VeryLarge, title: 'Large Enterprise' },
];

export const CompanySizeSection = ({
  companySizes,
  changeHandler,
}: CompanySizeSectionProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const onRequirementChipClick = (clickedCompanySize: CompanySizeTierEnum) => {
    const selected = companySizes?.includes(clickedCompanySize);

    if (selected) {
      changeHandler(companySizes.filter((companySize) => companySize !== clickedCompanySize));
    } else {
      const slicedArray = companySizes.slice();
      slicedArray.push(clickedCompanySize);
      changeHandler(slicedArray);
    }
  };

  return (
    <EditPositionPreferencesSection
      emoji="👕"
      title={ translate(STRING_KEYS.EDIT_POSITION_PREFERENCES_DIALOG.SECTIONS.COMPANY_SIZE) }
    >
      <SuggestionListContainer>
        { companySizeConfig.map((item) => (
          <RequirementChip
            key={ item.size }
            title={ item.title }
            selected={ companySizes?.includes(item.size) }
            onClick={ () => onRequirementChipClick(item.size) }
          />
        ))}
      </SuggestionListContainer>
    </EditPositionPreferencesSection>
  );
};
